module.exports = __webpack_public_path__ + "static/media/layout.836ac4e0.svg";